import { PhitoRoute, PhitoRoutes } from '../../app/app/phito-routes';
import { PermissionAction } from './role-and-permissions/role-and-permission';

export const USER_ROUTES = {
    users: new PhitoRoute(
        'Benutzer',
        'person',
        PermissionAction.Ansehen('Administration', 'Benutzer'),
        'administration/benutzer',
        () => ['administration', 'benutzer'],
        import('./phito-user/phito-user.component').then((m) => m.PhitoUserComponent),
    ) satisfies PhitoRoute<[]>,
    usergroups: new PhitoRoute(
        'Benutzergruppen',
        'group',
        PermissionAction.Ansehen('Administration', 'Benutzergruppen'),
        'administration/benutzergruppen',
        () => ['administration', 'benutzergruppen'],
        import('./usergroup/usergroups/usergroups.component').then((m) => m.UsergroupsComponent),
    ) satisfies PhitoRoute<[]>,
    roles: new PhitoRoute(
        'Rollen und Rechte',
        'security',
        PermissionAction.Ansehen('Administration', 'Rollen'),
        'administration/rollenundrechte',
        () => ['administration', 'rollenundrechte'],
        import('./role-and-permissions/role-and-permissions.component').then((m) => m.RoleAndPermissionsComponent),
    ) satisfies PhitoRoute<[]>,
    userSessions: new PhitoRoute(
        'Benutzer Sessions',
        'history',
        new PermissionAction('System', 'System', 'Sessions ansehen'),
        'administration/usersessions',
        () => ['administration', 'usersessions'],
        import('./user-sessions/user-sessions.component').then((m) => m.UserSessionsComponent),
    ) satisfies PhitoRoute<[]>,
    userSettings: new PhitoRoute(
        'Benutzereinstellungen',
        'user',
        new PermissionAction('Administration', 'User', 'Eigene Benutzereinstellungen sichern'),
        'administration/usersettings',
        () => ['administration', 'usersettings'],
        import('../../modules/user-settings/user-settings/user-settings.component').then(
            (mod) => mod.UserSettingsComponent,
        ),
    ) satisfies PhitoRoute<[]>
} satisfies PhitoRoutes;

export const ADMINISTRATION_ROUTES = {
    pushNotificationsConfig: new PhitoRoute(
        'Push Notifications',
        'notifications_active',
        PermissionAction.Ansehen('System', 'Push Notification Configs'),
        'administration/pushnotifications/config',
        () => ['administration', 'pushnotifications', 'config'],
        import('./push-notification/push-notification-config/push-notification-config.component').then(
            (m) => m.PushNotificationConfigComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    dbvariables: new PhitoRoute(
        'DB Variablen',
        'tune',
        PermissionAction.Ansehen('Administration', 'Variables'),
        'administration/dbvariables',
        () => ['administration', 'dbvariables'],
        import('./phito-variable/phito-variable.component').then((m) => m.PhitoVariableComponent),
    ) satisfies PhitoRoute<[]>,
    companies: new PhitoRoute(
        'Mandanten',
        'business',
        PermissionAction.Ansehen('Administration', 'Company'),
        'administration/companies',
        () => ['administration', 'companies'],
        import('./company/company.component').then((m) => m.CompanyComponent),
    ) satisfies PhitoRoute<[]>,
    tags: new PhitoRoute(
        'Tags',
        'label',
        PermissionAction.Ansehen('Administration', 'Tags'),
        'administration/tags',
        () => ['administration', 'tags'],
        import('./tags/tags.component').then((m) => m.TagsComponent),
    ) satisfies PhitoRoute<[]>,
    colors: new PhitoRoute(
        'Farben',
        'palette',
        PermissionAction.Ansehen('PhitoColor', 'PhitoColor'),
        'administration/colors',
        () => ['administration', 'colors'],
        import('./phito-color/phito-color.component').then((m) => m.PhitoColorComponent),
    ) satisfies PhitoRoute<[]>,
    apiKeys: new PhitoRoute(
        'API-KEYS',
        'vpn_key',
        PermissionAction.Ansehen('Administration', 'Api Keys'),
        'administration/apikeys',
        () => ['administration', 'apikeys'],
        import('./phito-api-key/phito-api-key.component').then((m) => m.PhitoApiKeyComponent),
    ) satisfies PhitoRoute<[]>,
    useractivities: new PhitoRoute(
        'Benutzeraktivitäten',
        'query_stats',
        PermissionAction.Ansehen('System', 'User Activity'),
        'administration/benutzeraktivitaeten',
        () => ['administration', 'benutzeraktivitaeten'],
        import('./user-activities/user-activities.component').then((mod) => mod.UserActivitiesComponent),
    ) satisfies PhitoRoute<[]>,
    timetracking: new PhitoRoute(
        'Zeiterfassung',
        'schedule',
        new PermissionAction('Administration', 'Workday', 'Time Tracking Dashboard'),
        'administration/zeiterfassung',
        () => ['administration', 'zeiterfassung'],
        import('../time-tracking/time-tracking/time-tracking.component').then((mod) => mod.TimeTrackingComponent),
    ) satisfies PhitoRoute<[]>,
    uservacation: new PhitoRoute(
        'Urlaub',
        'beach_access',
        PermissionAction.Ansehen('Administration', 'User Vacation Days'),
        'administration/vacation',
        () => ['administration', 'vacation'],
        import('../user-vacation/user-vacation-days/user-vacation-days.component').then(
            (mod) => mod.UserVacationDaysComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    uservacationconfig: new PhitoRoute(
        'Urlaubskonfiguration',
        'settings_suggest',
        PermissionAction.Ansehen('Administration', 'User Vacations'),
        'administration/vacationconfig',
        () => ['administration', 'vacationconfig'],
        import('../user-vacation/user-vacation-configuration/user-vacation-configuration.component').then(
            (m) => m.UserVacationConfigurationComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    bulkletter: new PhitoRoute(
        'Serienbrief',
        'mail_outline',
        PermissionAction.Ansehen('Documents', 'Document'),
        'administration/bulkletter',
        () => ['administration', 'bulkletter'],
        import('../../components/bulk-letter/bulk-letter/bulk-letter.component').then(
            (mod) => mod.BulkLetterComponent,
        ),
    ) satisfies PhitoRoute<[]>,
    textblocks: new PhitoRoute(
        'Textblöcke',
        'article',
        PermissionAction.Ansehen('Administration', 'Textbloecke'),
        'administration/textblocks',
        () => ['administration', 'textblocks'],
        import('./text-blocks/text-block/text-block.component').then((mod) => mod.TextBlockComponent),
    ) satisfies PhitoRoute<[]>,
    backups: new PhitoRoute(
        'Backups',
        'backup',
        PermissionAction.Ansehen('Administration', 'Backups'),
        'administration/backups',
        () => ['administration', 'backups'],
        import('./backups/backups.component').then(
            (m) => m.BackupsComponent)
    ),
    qrcodescanresult: new PhitoRoute(
        'QR Code',
        'qr_code_2',
        PermissionAction.Ansehen('Administration', 'QRCode'),
        'qr/:id', // Route im Backend
        (qrcode: string) => ['qr', qrcode],
        import('../qrcode-manager/qrcode-manager/qrcode-manager.component').then(
            (m) => m.QRCodeManagerComponent,
        ),
    )
} satisfies PhitoRoutes;
